import { CampaignState } from 'modules/domains/campaign';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { CampaignSummaryOverflowMenu } from '../Actions/CampaignSummaryOverflowMenu';
import {
  ViewAnalyticsAction,
  CancelCampaignAction,
  AbortCampaignAction,
  DisplayCampaignNowAction,
  ScheduleDisplayCampaignAction,
  RescheduleDisplayCampaignAction,
} from '../Actions';

/**
 * Mapper of actions for a given campaign state
 */
const ELIGIBILITY_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER: Record<
  CampaignState,
  (() => JSX.Element | null)[]
> = {
  [CampaignState.Draft]: [DisplayCampaignNowAction, ScheduleDisplayCampaignAction],
  [CampaignState.Ready]: [DisplayCampaignNowAction, ScheduleDisplayCampaignAction],

  [CampaignState.Scheduled]: [
    CampaignSummaryOverflowMenu,
    RescheduleDisplayCampaignAction,
    CancelCampaignAction,
  ],

  [CampaignState.Running]: [ViewAnalyticsAction, AbortCampaignAction],

  [CampaignState.Finished]: [ViewAnalyticsAction],
  [CampaignState.Aborted]: [ViewAnalyticsAction],
  [CampaignState.Archived]: [ViewAnalyticsAction],

  // Eligibility doesn't currently support these states
  [CampaignState.Recalled]: [],
  [CampaignState.Recalling]: [],
  [CampaignState.Recurring]: [],
};

export const EligibilityCampaignSummaryViewActions = () => {
  const {
    campaign: { campaignState },
  } = useCampaignContext();

  const actions = ELIGIBILITY_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER?.[campaignState];

  return (
    <>
      {actions?.map((Action, i) => (
        <Action key={i} />
      ))}
    </>
  );
};
